import { render, staticRenderFns } from "./AdsNegativeKey.vue?vue&type=template&id=90170670"
import script from "./AdsNegativeKey.vue?vue&type=script&lang=js"
export * from "./AdsNegativeKey.vue?vue&type=script&lang=js"
import style0 from "./AdsNegativeKey.vue?vue&type=style&index=0&id=90170670&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports